
import { defineComponent, ref, PropType, computed, onMounted, getCurrentInstance } from 'vue'
import useRouter from '../../../../hooks/useRouter'
import { Project } from '../../../../types/main'
import cloneDeep from 'lodash/cloneDeep'
import debounce from 'lodash/debounce'
import BaseInputOutlined from '../../../inputs/BaseInputOutlined.vue'
import { EditedActivation } from '../../../../types/GCB2'
import { checkInputIsIntNumber } from '../../../../utils'
import DatePicker from '../../../ui/DatePicker.vue'

export default defineComponent({
    name: 'MassEditAutomailSettings',
    components: { BaseInputOutlined, DatePicker },
    props: {
        value: { type: Object as PropType<EditedActivation>, required: true },
        automailValidate: { type: Object, required: false },
        type: { type: String, required: false }
    },
    computed: {
        project() {
            const { useProject } = require('@/hooks/useProject')
            const { project } = useProject()
            return project
        },
    },
    setup(props, { emit }) {
        const root = getCurrentInstance()!.proxy
        const { route } = useRouter(root)
        const project = computed<Project>(() => root.$store.getters.projectById(route.value.params.id))
        const currentValue = ref(props.value.extra.automail.isDeleted)
        const waBtnDisabled = computed(() => {
            const whatsappStatus = root.$store.state.whatsappStatus
            if (!whatsappStatus || whatsappStatus?.statusSubsystem !== 'on') return false
            return whatsappStatus.aliveStatus === 'dead'
        })
        const automailInit = ref(null)
        if (waBtnDisabled.value) currentValue.value = true
        const formInput = debounce((e: any) => emit('validation-updated', e), 100)
        const clear = () => {
            (root.$refs as any).form.resetValidation()
            props.value.extra.automail.isDeleted = true
            props.value.extra.automail.limitOneMailing = automailInit.value.limitOneMailing
            props.value.extra.automail.commonLimit = automailInit.value.commonLimit
            props.value.extra.automail.intervalInMinutes = automailInit.value.intervalInMinutes
            props.value.extra.automail.sendAfterDate = null
            props.value.extra.automail.sendBeforeDate = null
        }
        const requiredRules = computed(() =>
            props.value.extra.automail?.isDeleted ? [] : [(v: any) => !!v || 'Обязательно']
        )
        const intervalInMinutesRules = computed(() =>
            props.value.extra.automail?.isDeleted
                ? []
                : [(v: any) => !!v || 'Обязательно', (v: any) => Number(v) >= 4 || 'Должно быть не меньше 4']
        )
        const timeRules = computed(() =>
            props.value.extra.automail?.isDeleted
                ? []
                : [(v: any) => !!v || 'Обязательно', (v: any) => v?.length === 5 || 'Обязательно']
        )
        const onSwitchChange = () => {
            props.automailValidate.isAutomail = !props.value.extra.automail.isDeleted
        }
        onMounted(() => {
            emit('validation-updated', true)
            props.automailValidate.isAutomail = !props.value.extra.automail.isDeleted
            automailInit.value = cloneDeep(props.value.extra.automail)
        })
        return {
            currentValue,
            formInput,
            checkInputIsIntNumber,
            requiredRules,
            intervalInMinutesRules,
            timeRules,
            waBtnDisabled,
            onSwitchChange,
            clear
        }
    },
})
